<template>
    <div class="class-list p-b-64 page">
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
        <div v-if="!indicatorType">
            <div style="padding-bottom: 70px">
                <div v-if="approveInfo.titleCustom && !isEditMode" style="padding: 10px 0px 10px 0px">
                    <van-field
                        v-model="title"
                        placeholder="请输入"
                        label="标题"
                        maxlength="20"
                        input-align="right"
                        :required="true"
                    ></van-field>
                </div>
                <div v-for="(cmpt, i) in itemsList" :key="i"
                     style="font-size: 15px; text-align: left;margin-bottom: 5px">
                    <createCompnents :cmpt="cmpt" :key="cmpt.componentName+'-'+i"
                                     :extra="{parentIndex: i}"></createCompnents>
                </div>
                <div v-if="!isEditMode" id="cmpt-process">
                    <van-cell
                        title="审批人"
                        :required="true">
                        <template slot>
                            <div class="ellipsis-multi-1" v-if="!processCustom" style="color: #a4afbc; font-size: 12px">
                                <span>已由管理员预置</span>
                                <span v-if="repeatType=='1'">,不去重</span>
                                <span v-else-if="repeatType=='2'">,相同审批人仅保留第一个</span>
                                <span v-else-if="repeatType=='3'">,相同审批人仅保留最后一个</span>
                                <span v-else-if="repeatType=='4'">,并将自动去重</span>
                            </div>
                            <div v-else style="color: #a4afbc; font-size: 12px">流程未设置</div>
                        </template>
                    </van-cell>
                    <van-row
                        style="background-color: white; padding: 5px 15px 10px 15px">
                        <van-col class="upload-image" v-for="(rule, i) in processList" :key=i span="6"
                                 tag="a">
                            <div class="process-item">
                                <div class="process-item-left">
                                    <div class="upload-image-layout"
                                         :style="{'height': '40px','width': '40px'}">
                                        <img class="portrait-shape" :src="getProcessPortrait(rule)"
                                             @click="pickRole(rule, i, rule.actType)"/>
                                        <img v-if="rule.actType == 'custom' && !processCustom"
                                             style="position: absolute;top: -2px;right: -4px;width: 16px;height: 16px;overflow: visible"
                                             src="../../assets/img/icon/编辑@3x.png">
                                        <img v-if="processCustom"
                                             @click="removeProcess(i)"
                                             style="position: absolute;top: -2px;right: -4px;width: 16px;height: 16px;overflow: visible"
                                             src="../../assets/img/icon/删除@3x.png">
                                    </div>
                                    <span
                                        style="font-size: 12px; color: #333; margin-top: 8px">{{getProcessName(rule)}}</span>
                                    <span class="process-item-role"
                                          :style="{'visibility': rule.remark ? 'visible':'hidden'}">{{rule.remark}}</span>
                                </div>
                                <div class="process-item-right">
                                    <img v-if="processCustom || i<processList.length-1"
                                         style="width: 16px;height: 16px; margin-top: 12px"
                                         src="../../assets/img/icon/arrow@3x.png">
                                </div>
                            </div>
                        </van-col>
                        <van-col v-if="processCustom" class="upload-image" span="6">
                            <div class="process-item">
                                <div class="process-item-left">
                                    <div class="upload-image-layout"
                                         :style="{'height': '40px','width': '40px'}">
                                        <img class="portrait-shape" src="../../assets/img/icon/添加照片@3x.png"
                                             @click="addRule"/>
                                    </div>
                                </div>
                                <div class="process-item-right"></div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div v-if="!isEditMode" style="margin-top: 5px">
                    <van-cell
                        title="抄送人">
                        <template slot>
                            <div class="ellipsis-multi-1" style="color: #a4afbc; font-size: 12px">
                                <span v-if="noticeType=='1'">仅全部同意后通知</span>
                                <span v-else-if="noticeType=='2'">仅发起时通知</span>
                                <span v-else-if="noticeType=='3'">发起时和全部同意后均通知</span>
                            </div>
                        </template>
                    </van-cell>
                    <van-row
                        style="background-color: white; padding: 5px 15px 10px 15px">
                        <van-col class="upload-image" v-for="(notifier, i) in notifierList" :key=i span="6"
                                 tag="a">
                            <div class="process-item">
                                <div class="process-item-left">
                                    <div class="upload-image-layout"
                                         style="height: 40px; width: 40px;">
                                        <img class="portrait-shape" :src="getNotifierPortrait(notifier)"/>
                                        <img v-if="notifier.canDelete" @click="notifierList.splice(i, 1)"
                                             style="position: absolute;top: -2px;right: -4px;width: 16px;height: 16px;overflow: visible"
                                             src="../../assets/img/icon/删除@3x.png">
                                    </div>
                                    <span
                                        style="font-size: 12px; color: #333; margin-top: 8px">{{getNotifierName(notifier)}}</span>
                                    <span class="process-item-role"
                                          :style="{'visibility': notifier.label ? 'visible':'hidden'}">{{notifier.label}}</span>
                                </div>
                                <div class="process-item-right"></div>
                            </div>
                        </van-col>
                        <van-col class="upload-image" span="6">
                            <div class="process-item">
                                <div class="process-item-left">
                                    <div class="upload-image-layout"
                                         style="height: 40px; width: 40px;">
                                        <img class="portrait-shape" src="../../assets/img/icon/添加照片@3x.png"
                                             @click="pickNotifier(notifierList.length)"/>
                                    </div>
                                </div>
                                <div class="process-item-right"></div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
            </div>

            <div v-if="showSubmit" style="position: fixed; left: 25px; bottom: 15px; right: 25px">
                <van-button type="default" @click="showResult"
                            style="width: 100%; color: #fff; background-color: #08B0FA; height: 45px; border-radius: 3px; border: 0px transparent solid">
                    提交
                </van-button>
            </div>

            <van-dialog
                v-model="duorenDialog"
            >
                <div style="padding: 15px 15px 15px 15px">
                    <span v-if="duorenDialogType=='or'" style="color: #bbb; font-size: 12px">以下成员一人审批即可</span>
                    <span v-else-if="duorenDialogType=='and'" style="color: #bbb; font-size: 12px">须以下所有人审批通过</span>
                    <div
                        style="display: flex; flex-direction: row; align-items: center;margin: 10px 0px 0px 20px"
                        v-for="(profileId, i) in duorenData"
                        :key="i">
                        <img class="portrait-shape portrait-size-30"
                             :src="userDetails[profileId].portraitImgUrl">
                        <span class="flow-row-user"
                              style="margin-left: 10px">{{userDetails[profileId].realName}}</span>
                    </div>
                </div>
            </van-dialog>
        </div>
    </div>
</template>

<script>
    import createCompnents from './createCompnents';
    import head from '../../mixins/head';
    import indicatorEmpty from './empty';
    import componnetInitValue from '../../mixins/component';
    import componentHybird from '../../mixins/component-hybird';

    export default {
        components: {
            createCompnents,
            indicatorEmpty
        },
        name: 'approve-create',
        mixins: [head, componentHybird, componnetInitValue],
        data() {
            return {
                title: '',
                approveInfo: {},
                userDetails: {}, //用户信息
                repeatType: '', //去重类型
                noticeType: '', //抄送类型
                processList: [],
                processCustom: true,
                notifierList: [],

                repeatCount: 0,
                cTimeout: '',
                timeoutIntervals: [],
                timeoutIntervalSpeed: '',

                duorenDialog: false,
                duorenDialogType: '',
                duorenData: [],

                isEditMode: false,
                detailData: {},

                condition: {},
                indicatorType: 0,
                indicatorMessage: '',

                showSubmit: false
            };
        },
        props: {},
        watch: {
            '$route': 'inited'
        },
        computed: {},
        created() {
        },
        mounted() {
            window.returnValue = (vals, extra) => {
                if (!this.returnValueApproveCreate(vals, extra)) {
                    this.returnValue(vals, extra);
                }
            };

            this.inited();
            this.init();
        },
        beforeDestroy() {
            this.graph.destroy();
        },
        methods: {

            init() {
                this.setTitle(this.$route.query.title || '');
                if (window.saveInstance[window.getCurrentPath()]) {
                    window.restoreSaveInstance(window.getCurrentPath(), this.$data);
                    if (!_.isEmpty(window.tempRelate) && !_.isEmpty(window.tempRelate.data)) {
                        let tempRelate = _.cloneDeep(window.tempRelate.data);
                        let extra = _.cloneDeep(window.tempRelate.extra);
                        window.tempRelate = {};
                        this.returnValue(JSON.stringify(tempRelate), JSON.stringify(extra));
                    }
                    if (this.flowData) {
                        this.initG6();
                    }
                } else {
                    this.getData();
                }
            },

            inited() {
                if (this.$route.name == 'approve-create') {
                    this.setTitle(this.$route.query.title || '创建审批');
                    window.moreButton({});
                    // for (let key in this.$data) {
                    //     if (_.isArray(this.$data[key])) {
                    //         this.$data[key] = [];
                    //     } else if (_.isObject(this.$data[key])) {
                    //         this.$data[key] = {};
                    //     } else if (_.isString(this.$data[key])) {
                    //         this.$data[key] = '';
                    //     } else if (_.isNumber(this.$data[key])) {
                    //         this.$data[key] = 0;
                    //     }
                    // }
                    // this.getData();
                }
            },

            getData() {
                this.isEditMode = this.$route.query.isEdit || false;
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id
                };
                console.log('before getData');
                this.$http.post('badu/eaa/queryCompanyApproveFormAndProcessSetting.do', param).then((response) => {
                    this.initData(response.data);
                    if (!this.isEditMode) {
                        let params = {};
                        if (response.data.condition) {
                            let a = JSON.parse(response.data.condition);
                            for (let i = 0; i < a.length; i++) {
                                let key = a[i]['paramKey'];
                                if (key == 'createdUser') {
                                    params[key] = this.$store.state.userInfo.profileId;
                                } else {
                                    params[key] = '';
                                }
                            }
                            this.condition = params;
                        }
                        this.getProcess(params);
                        return;
                    }
                    this.showSubmit = true;
                    this.$toast.clear();
                }).catch((error) => {
                    this.$toast.clear();
                    this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                    this.indicatorMessage = error.rspMsg;
                });
                ;
            },

            getProcess(params) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                console.log('getProcess', params);
                if (!params) {
                    params = '{}';
                }
                let param = {
                    approveId: this.$route.query.id,
                    params: JSON.stringify(params)
                };
                this.$http.post('badu/eaa/queryNowApproveProcess.do', param).then((response) => {
                    if (response.rspCode == 0) {
                        this.initProcess(response.data);
                        this.showSubmit = true;
                    }
                    this.$toast.clear();
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                });
            },

            initData(data) {
                this.approveInfo = data;
                //初始化表单
                let table = JSON.parse(data.table);

                if (this.$route.query.isAgain || this.isEditMode) {
                    this.detailData = _.cloneDeep(window.tempData);
                    if (this.approveInfo.titleCustom) {
                        this.title = _.cloneDeep(window.tempTitle);
                    }
                    window.tempData = null;
                    window.tempTitle = null;
                }
                if (this.isEditMode) {
                    let editForm = [];
                    let tempForm = _.cloneDeep(window.tempForm);
                    for (let i = 0; i < tempForm.length; i++) {
                        for (let j = 0; j < table.length; j++) {
                            if (tempForm[i].props.id == table[j].props.id) {
                                editForm.push(_.cloneDeep(table[j]));
                            }
                        }
                    }
                    table.splice(0, table.length, ...editForm);
                }
                this.initRelate(table, this.detailData);
                this.initFormValue(this.itemsList, table, this.detailData);

                this.repeatType = data.repeatType;
                this.noticeType = data.noticeType;
            },

            initProcess(process) {
                console.log('initProcess', process);
                //用户信息
                if (process.userDetails) {
                    this.userDetails = process.userDetails;
                }
                //初始化审批人
                this.processList.splice(0, this.processList.length);
                if (process.rules && process.rules.length > 0) {
                    this.processCustom = false;
                    for (let i = 0; i < process.rules.length; i++) {
                        let rule = process.rules[i];
                        if (!rule.approvals) {
                            rule.approvals = [];
                        } else {
                            let users = [];
                            for (let j = 0; j < rule.approvals.length; j++) {
                                let profileId = rule.approvals[j];
                                if (process.userDetails[profileId]) {
                                    users.push(profileId);
                                }
                            }
                            rule.approvals = users;
                        }
                        if (rule.actType == 'custom' || rule.approvals.length > 0) {
                            this.processList.push(_.cloneDeep(rule));
                        }
                    }
                }
                //初始化抄送人
                this.notifierList.splice(0, this.notifierList.length);
                if (process.notifiers && process.notifiers.length > 0) {
                    for (let i = 0; i < process.notifiers.length; i++) {
                        let notifier = process.notifiers[i];
                        if (notifier.type == 'role') {
                            if (process.roleDetails && process.roleDetails[notifier.value]) {

                            } else {
                                continue;
                            }
                        }
                        notifier.canDelete = false;
                        this.notifierList.push(_.cloneDeep(notifier));
                    }
                }
            },

            showResult() {
                if (this.approveInfo.titleCustom && !this.title) {
                    this.$toast({
                        type: 'text',
                        forbidClick: true,
                        message: '标题不能为空',
                        duration: 1000
                    });
                    return;
                }
                let emptyResult = this.checkEmpty(this.itemsList);
                if (!emptyResult.success) {
                    this.showEmptyTip(emptyResult.label, emptyResult.extra);
                    return;
                }

                let result = this.loopCompnents(this.itemsList);
                console.log('showResult-content', result);
                let showContent = this.listDetails(this.itemsList, result);
                console.log('showResult-showContent', showContent);

                if (this.isEditMode) {
                    let temp = _.cloneDeep(this.detailData);
                    for (var key in result) {
                        temp[key] = result[key];
                    }
                    let showContent = this.listDetails(temp);
                    this.update(showContent, temp);
                } else {
                    let processEnable = true;
                    if (this.processCustom) {
                        if (this.processList.length == 0) {
                            processEnable = false;
                        }
                    } else {
                        for (let i = 0; i < this.processList.length; i++) {
                            if (!this.processList[i].approvals || this.processList[i].approvals.length == 0) {
                                processEnable = false;
                                break;
                            }
                        }
                    }
                    if (!processEnable) {
                        this.ScrollToControl('cmpt-process');
                        this.$toast({
                            forbidClick: true,
                            message: '请选择审批人',
                            duration: 1000
                        });
                        return;
                    }
                    console.log('showResult-process', this.processList);
                    console.log('showResult-notifier', this.notifierList);

                    this.submit(showContent, result, {
                        rules: this.processList,
                        notifiers: this.notifierList
                    });
                }
            },

            submit(showContent, content, process) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    approveId: this.$route.query.id,
                    approveName: this.approveInfo.approveName,
                    title: this.title || '',
                    showContent: JSON.stringify(showContent),
                    content: JSON.stringify(content),
                    form: this.approveInfo.table,
                    process: JSON.stringify(process),
                    conditions: this.approveInfo.condition,
                    noticeType: this.approveInfo.noticeType,
                    repeatType: this.approveInfo.repeatType,
                    opinionRemind: this.approveInfo.opinionRemind,
                    opinionRequired: this.approveInfo.opinionRequired,
                    opinionHide: this.approveInfo.opinionHide
                };
                console.log('submit', param);
                this.$http.post('badu/eaa/addApproveMoving.do', param).then((response) => {
                    if (response.rspCode == 0) {
                        this.$toast.clear();
                        this.$toast.success({
                            forbidClick: true,
                            message: '提交成功'
                        });
                        setTimeout(() => {
                            this.REPLACE({
                                name: 'approve-detail',
                                query: { id: response.data, time: new Date().getTime() }
                            });
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            forbidClick: true,
                            message: '提交失败'
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                    this.$toast.fail({
                        forbidClick: true,
                        message: '网络异常'
                    });
                });
                ;
            },

            update(showContent, content) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.detailId,
                    showContent: JSON.stringify(showContent),
                    content: JSON.stringify(content)
                };
                console.log('update', param);
                this.$http.post('badu/eaa/updateApproveMoving.do', param).then((response) => {
                    if (response.rspCode == 0) {
                        this.$toast.clear();
                        this.$toast.success({
                            forbidClick: true,
                            message: '提交成功'
                        });
                        setTimeout(() => {
                            this.GO(-1);
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            forbidClick: true,
                            message: '提交失败'
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                    this.$toast.fail({
                        forbidClick: true,
                        message: '网络异常'
                    });
                });
                ;
            },

            getProcessPortrait(rule) {
                if (rule.approvals) {
                    if (rule.approvals.length == 1) {
                        return this.userDetails[rule.approvals[0]].portraitImgUrl;
                    } else if (rule.approvals.length > 1) {
                        if (rule.actType == 'or' || rule.actType == 'and') {
                            return require('../../assets/img/icon/duoren.png');
                        }
                    }
                }
                //自选+号
                return require('../../assets/img/icon/添加照片@3x.png');
            },

            getNotifierPortrait(notifier) {
                if (notifier.type == 'user') {
                    return this.userDetails[notifier.value].portraitImgUrl;
                }
                return require('../../assets/img/icon/duoren.png');
            },

            getNotifierName(notifier) {
                if (notifier.type == 'user') {
                    return this.userDetails[notifier.value].realName;
                } else if (notifier.type == 'role') {
                    return '角色';
                } else if (notifier.type == 'management') {
                    return '主管';
                }
                return '';
            },

            getProcessName(rule) {
                if (rule.approvals) {
                    if (rule.approvals.length == 1) {
                        return this.userDetails[rule.approvals[0]].realName;
                    } else if (rule.approvals.length > 1) {
                        if (rule.actType == 'or') {
                            return rule.approvals.length + '人或签';
                        } else if (rule.actType == 'and') {
                            return rule.approvals.length + '人会签';
                        }
                    }
                }
                return '请选择';
            },

            pickRole(rule, processIndex) {
                console.log('pickRole', rule, processIndex);
                if (rule.actType == 'custom') {
                    let extra = {
                        processIndex: processIndex
                    };
                    window.pickRole(rule.roleIds[0], false, rule.approvals, extra);
                } else if (rule.actType == 'or' || rule.actType == 'and') {
                    this.duorenDialog = true;
                    this.duorenDialogType = rule.actType;
                    this.duorenData.splice(0, this.duorenData.length, ...rule.approvals);
                }
            },

            pickRuleByMobile(processIndex, actType) {
                let extra = {
                    processIndex: processIndex,
                    actType: actType
                };
                window.pickUser(actType == 'or' || actType == 'and', null, 0, false, extra);
            },

            pickNotifier(notifierIndex) {
                window.pickUser(true, null, 0, false, {
                    notifierIndex: notifierIndex
                });
            },

            addRule() {
                this.$createActionSheet({
                    data: [
                        {
                            content: '指定人员'
                        },
                        {
                            content: '多人会签'
                        },
                        {
                            content: '多人或签'
                        }
                    ],
                    onSelect: (item, index) => {
                        if (index == 0) {
                            this.pickRuleByMobile(this.processList.length);
                        } else if (index == 1) { //多人会签
                            this.pickRuleByMobile(this.processList.length, 'and');
                        } else if (index == 2) { //多人或签
                            this.pickRuleByMobile(this.processList.length, 'or');
                        }
                    },
                    onCancel: () => {
                    }
                }).show();
                // this.pickRuleByMobile(this.processList.length);
            },

            removeProcess(i) {
                this.processList.splice(i, 1);
            },

            /**
             * js调原生后返回数据
             * @param val
             * @param extra js调原生时传过去的值
             */
            returnValueApproveCreate(val, extra) {
                console.log('returnValue', val, extra);
                let extraData = JSON.parse(extra);
                if (extraData.returnType == 'pickUser') {
                    if (extraData.processIndex != null) {
                        let user = JSON.parse(val);
                        let preIndex = extraData.processIndex - 1;
                        if (preIndex >= 0) {
                            if (this.processList[preIndex].approvals.length == 1 && user.length == 1 && user[0].profileId == this.processList[preIndex].approvals[0]) {
                                this.$toast({
                                    forbidClick: true,
                                    message: '该审批人已存在',
                                    duration: 1000
                                });
                                return;
                            }
                        }
                        this.setProcessValue(val, extra);
                        return true;
                    } else if (extraData.notifierIndex != null) {
                        let profileIds = this.updateUserDetails(JSON.parse(val));
                        let alreadyExist = false;
                        for (let i = 0; i < profileIds.length; i++) {
                            let needAdd = true;
                            for (let j = 0; j < this.notifierList.length; j++) {
                                if (profileIds[i] == this.notifierList[j].value) {
                                    alreadyExist = true;
                                    needAdd = false;
                                    break;
                                }
                            }
                            if (needAdd) {
                                this.notifierList.splice(extraData.notifierIndex, 0, {
                                    type: 'user',
                                    value: profileIds[i],
                                    canDelete: true
                                });
                            }
                        }
                        if (alreadyExist) {
                            this.$toast({
                                forbidClick: true,
                                message: '该抄送人已存在',
                                duration: 1000
                            });
                        }
                        return true;
                    }
                } else if (extraData.returnType == 'pickRole') {
                    if (extraData.processIndex != null) {
                        let ids = this.updateUserDetails(JSON.parse(val));
                        let rule = this.processList[extraData.processIndex];
                        if (rule.approvals) {
                            rule.approvals.splice(0, rule.approvals.length, ...ids);
                        } else {
                            rule.approvals = ids;
                        }
                        return true;
                    }
                }
                return false;
            },


            /**
             * 设置自选审批人
             * @param val
             * @param extra js调原生时传过去的值
             */
            setProcessValue(val, extra) {
                console.log('setProcessValue', val, extra);
                let extraData = JSON.parse(extra);
                let processIndex = extraData.processIndex;
                let actType = extraData.actType;
                let users = JSON.parse(val);
                let ids = this.updateUserDetails(users);
                if (actType == 'custom') {
                    this.processList[processIndex].actType = actType;
                    this.processList[processIndex].approvals.splice(0, this.processList[processIndex].approvals.length, ...ids);
                } else {
                    this.processList.splice(processIndex, 0, {
                        approvals: ids,
                        actType: actType,
                        showHide: true,
                        canUpdate: false
                    });
                }
            },

            updateUserDetails(users) {
                let ids = [];
                for (let i = 0; i < users.length; i++) {
                    let user = users[i];
                    ids.push(Number(user.profileId));
                    if (!this.userDetails[ids[i]]) {
                        this.userDetails[ids[i]] = {
                            realName: user.realName,
                            portraitImgUrl: user.portraitImgUrl
                        };
                    }
                }
                return ids;
            }

        }
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-create.scss';

    .upload-image-layout {
        position: relative;
        overflow: visible;
    }
</style>
